module.exports = __webpack_public_path__ + "assets/img/cf_3.0f4bdad0.png";